
import React from 'react';
import ZNetwork from "./znetwork.js";
import ZUtil from "./zutil.js";
import { ROUTER } from "./AMCRouter.js";
import PleaseStandBy from "./PleaseStandBy";

export default class ZooBillingPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		ZNetwork.get("billing", (err, data) => {
			if (err) {
				this.setState({ error: err });
			} else {
				this.setState({ data: data });
			}
		});
	}
	toggleCategory = (cat) => {
		this.setState({ selected_category: this.state.selected_category === cat ? null : cat });
	}
	launchStripePortal = () => {
		ZNetwork.get("checkout:portal", (err) => {

		});
	}
	render() {
		let { error, data, selected_category } = this.state;
		if (error) {
			return <h1 className="CENTEREDPART">You do not have permission to view billing for this organization</h1>;
		}
		if (!data) {
			return <PleaseStandBy />;
		}
		let summary = { train: {}, test: {}, deploy: {}, predict: {}, poll: {}, logs: { label: "logging" }, housekeep: {} };
		let total = 0;
		let usages = data.usages;
		let purchases = data.purchases;
		usages = usages.sort( (a, b) => a.updated_at - b.updated_at );
		usages.forEach( d => {
			let ctx = d.context;
			let record = summary[ctx];
			if (record) {
				record.computes = (record.computes || 0) + (d.computes || 0);
				record.count = (record.count || 0) + 1;
			} else {
				summary.housekeep.computes = (summary.housekeep.computes || 0) + (d.computes || 0);
				summary.housekeep.count = (summary.housekeep.count || 0) + 1;
			}
//console.log("d.udated_at=" + d.updated_at + ", d.contxext=" + ctx + ", d.computes=" + d.computes + ", total this cat: " + (record || summary.housekeep).computes);
			total += (d.computes || 0);
		});
		let getTopServices = (category) => {
			let computes_per_service = {};
			let invokes_per_service = {};
			usages.forEach( d => {
				if (d.context === category) {
					computes_per_service[d.service_uri] = (computes_per_service[d.service_uri] || 0) + (d.computes || 0);
					invokes_per_service[d.service_uri] = (invokes_per_service[d.service_uri] || 0) + 1;
				}
			});
			let sorted_services = Object.keys(computes_per_service).sort( (a, b) => { return computes_per_service[a] > computes_per_service[b] } );
			let list = sorted_services.map( uri => {
				return <div key={category + "-" + uri} className="ZooBillingPageDetail">
					<div className="ZooBillingPageDetailCalls">{invokes_per_service[uri]} calls</div>
					<div className="ZooBillingPageDetailService">
						<a href={"/zoo/" + uri} onClick={ e => { e.preventDefault(); return ROUTER.pushRoute("/zoo/" + uri); } }>{uri}</a>
					</div>
					<div className="ZooBillingPageDetailAmount">{ZUtil.toShortNumber(computes_per_service[uri], 6)}
					</div>
				</div>
			});
			return <div className="ZooBillingPageDetails">{list}</div>;
		};
		let lines = Object.keys(summary).map( category => {
			let detail = summary[category];
			let details_available = detail.computes && category !== "housekeep";
			return (
				<div key={category} className={"ZooBillingPageSection" + (details_available ? " ZooBillingPageSectionToggleable" : "")} onClick={ e => { if (details_available) { this.toggleCategory(category); } } }>
					<div className={"ZooBillingPageSectionCategory ZooBillingPageSection" + category}></div>
					<div className="ZooBillingPageSectionName">{detail.label || category + "ing"}</div>
					<div className="ZooBillingPageSectionAmount">{ZUtil.toShortNumber(detail.computes || 0, 6)} <span title="calls">{ detail.count ? "(" + ZUtil.toShortNumber(detail.count) + ")" : '' }</span>
					</div>
					{category === selected_category ? getTopServices(category) : ''}
				</div>
			)
		});
		let paids = purchases.sort( (a, b) => a.timestamp - b.timestamp ).map( p => {
			let desc;
			switch (p.action) {
				case "cancelsubscription" : 
					desc = "Cancelled " + p.nickname + " subscription";
					break;
				case "subscribe" : 
					desc = "Subscribed to " + p.nickname + " plan";
					break;
				case "updatesubscription" : 
					desc = "Subscribed to " + p.nickname + " plan";
					break;
				case "purchase" : 
					desc = p.nickname;
					break;
				default:
					desc = p.action;
			}
						
			return (
				<div key={p.timestamp} className="ZooBillingPageSection">
					<div className="ZooBillingPagePurchaseDate">{ZUtil.toShortDate(p.timestamp).split(" ")[0]}</div>
					<div className="ZooBillingPagePurchaseName">{desc}</div>
					<div className="ZooBillingPagePurchaseCapacity">{ZUtil.toShortNumber(p.capacity || 0, 2)} </div>
					<div className="ZooBillingPagePurchaseAmount">${ZUtil.toShortNumber((p.amount || 0)/100, 2)}</div>
				</div>
			);
		});
		return (
			<div className="ZooBillingPage">
				<h1>Automatic.ai Services Used <span>Computes</span></h1>
				{lines}
				<div className="ZooBillingPageTotals">
					<div className="ZooBillingPageTotalLabel">Total <span>(30 days)</span></div>
					<div className="ZooBillingPageTotal">{ZUtil.toShortNumber(total)}</div>
				</div>
				<div className="ZooBillingPagePurchases">
					<h1>Automatic.ai Services Purchased</h1>
					{paids}
				</div>

				<div>{ ZUtil.isDevelopment() ? <button className="ZooBillingManageStripeAccountButton" onClick={this.launchStripePortal} >Manage Your Account Details</button> : '' }</div>
				<div className="ZooBillingPageSmallPrint">
 Estimated computes used during the last 30 days. Estimated computes shown on this page, or shown on any notifications that we send to you, may differ from your actual computes for this statement period. This is because estimated computes presented on this page do not include usage computes accrued during this statement period after the date you view this page. 
				</div>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/ZooBillingPage.js